module.exports = __webpack_public_path__ + "static/media/Mist-14.b2082d48.jpg";